import { useState } from 'react'
import styled, { useTheme } from 'styled-components/native'
import {
  border,
  BorderProps,
  color,
  ColorProps,
  flexbox,
  FlexboxProps,
  layout,
  LayoutProps,
  position,
  PositionProps,
  space,
  SpaceProps,
  system,
  variant,
} from 'styled-system'
import { extraConfig } from './ExtraConfig'

const StyledPressable = styled.Pressable<
  ColorProps | SpaceProps | FlexboxProps | BorderProps | LayoutProps | PositionProps
>`
  ${color}
  ${space}
  ${flexbox}
  ${layout}
  ${position}
  ${variant({
    prop: 'customBorderStyle',
    variants: {
      borderTextfield: {
        borderWidth: 'TINY',
        borderColor: 'BORDER_TEXTFIELD',
        borderRadius: 'MEDIUM',
      },
      borderPrimary: {
        borderWidth: 'TINY',
        borderColor: 'BORDER_PRIMARY',
        borderRadius: 'MEDIUM',
      },
      borderSecondary: {
        borderWidth: 'TINY',
        borderColor: 'BORDER_SECONDARY_BUTTON',
        borderRadius: 'MEDIUM',
      },
      borderDestructive: {
        borderWidth: 'TINY',
        borderColor: 'BORDER_DESTRUCTIVE',
        borderRadius: 'MEDIUM',
      },
      borderPending: {
        borderWidth: 'TINY',
        borderColor: 'BORDER_PENDING',
        borderRadius: 'MEDIUM',
      },
      borderSuccess: {
        borderWidth: 'TINY',
        borderColor: 'BORDER_SUCCESS',
        borderRadius: 'MEDIUM',
      },
    },
  })}
  ${border}
  ${variant({
    prop: 'customShadowStyle',
    variants: {
      shadowPrimary: {
        shadowColor: (props: any) => props.colors.PRIMARY,
        shadowRadius: (props: any) => props.radii.MEDIUM,
        shadowOffset: (props: any) => ({ width: props.sizes.ZERO, height: props.sizes.ONE }),
        shadowOpacity: (props: any) => props.opacities.MEDIUM,
      },
      shadowSecondary: {
        shadowColor: (props: any) => props.colors.RED,
        shadowRadius: (props: any) => props.radii.MEDIUM,
        shadowOpacity: (props: any) => props.opacities.MEDIUM,
        shadowOffset: (props: any) => ({ width: props.sizes.ZERO, height: props.sizes.ONE }),
      },
    },
  })}
  ${system(extraConfig as any)}
`
const StyledTouchable = (props) => {
  const [isPressed, setIsPressed] = useState(false)
  const theme = useTheme()
  const underlayColor = props.underlayColor ? theme.colors?.[props.underlayColor] ?? props.underlayColor : undefined
  const bgColor = props.bg ? theme.colors?.[props.bg] ?? props.bg : undefined
  const backgroundColor = props.backgroundColor
    ? theme.colors?.[props.backgroundColor] ?? props.backgroundColor
    : undefined
  const defaultColor = bgColor ?? backgroundColor
  return (
    <StyledPressable
      {...props}
      backgroundColor={isPressed ? underlayColor : defaultColor}
      onPressIn={(...args) => {
        setIsPressed(true)
        if (props.onPressIn) {
          props.onPressIn(...args)
        }
      }}
      onPressOut={(...args) => {
        setIsPressed(false)
        if (props.onPressOut) {
          props.onPressOut(...args)
        }
      }}
    />
  )
}
export { StyledTouchable }
